//#region IMPORTS
import { Cog6ToothIcon } from "@heroicons/react/24/outline";
import { InstoreOrder } from "../../models/instoreOrder";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
//#endregion

//#region INTERFACE
interface Props {
  inProgressHandler: () => void;
  hide?: boolean;
  instoreOrder: InstoreOrder;
}
//#endregion

export default function InstoreOrdersTableRowActionInProgress({
  inProgressHandler,
  instoreOrder,
  hide = false,
}: Props) {
  //#region RENDER
  return !hide ? (
    <Fragment>
      <button
        data-tooltip-content="Set order in progress?"
        data-tooltip-variant="dark"
        data-tooltip-place="left"
        data-tooltip-id={String(instoreOrder.id) + "inprogress"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
      >
        <Cog6ToothIcon
          className="h-5 w-5 text-amber-600 hover:cursor-pointer hover:text-amber-400"
          onClick={inProgressHandler}
          type="button"
        />
      </button>
      <Tooltip id={String(instoreOrder.id) + "inprogress"} />
    </Fragment>
  ) : null;
  //#endregion
}
